global.opt = function(key) {
    if (/^[A-Z][^._]*$/.test(key)) key = decamelize(key);
    let keys = key.split('.');
    if (keys.length === 1) keys.unshift('misc');

    let varObj = configs[keys[0]] || (configs[keys[0]] = {});
    keys.shift();
    let finalKey = keys.join('_');

    let conf = varObj[finalKey];

    return conf ? conf : undefined;
}

global.linkFormat = function(url, urlType = 'internal') {
    switch (urlType) {
        case 'page':
            // rien à faire
            break;

        case 'anchor':
            url = `javascript: cmsAnchor('#${url}');`;
            break;

        case 'magnet':
            url = `magnet:${url}`;
            break;

        case 'torrent':
            url = `torrent:${url}`;
            break;

        case 'email':
            url = `mailto:${url}`;
            break;

        case 'tel':
            url = `tel:${url}`;
            break;

        case 'js':
            url = `javascript:${url}`;
            break;

        case 'action':
            url = `javascript: browserActionRun('${url}');`;
            break;

        case '':
            url = '';
            break;
    }

    return url;
}